import { useTheme } from "../../theme/ThemeProvider"
import type { ReactNode } from "react"

export default function InvoiceFailure() {
  const { theme } = useTheme()
  const isFairy = theme === "fairy"
  return (
    <CenteredMessage isFairy={isFairy} title="Payment incomplete">
      The payment did not succeed. Please retry or contact the merchant if the issue persists.
    </CenteredMessage>
  )
}

function CenteredMessage({
  isFairy,
  title,
  children,
}: {
  isFairy: boolean
  title: string
  children: ReactNode
}) {
  const background = isFairy ? "rgba(255,255,255,0.95)" : "rgba(18,18,20,0.85)"
  const border = isFairy ? "1px solid rgba(46,214,181,0.35)" : "1px solid rgba(255,43,79,0.45)"
  const heading = isFairy ? "#1f2d42" : "var(--text)"
  const muted = isFairy ? "#4b5a6d" : "var(--muted)"
  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "clamp(16px, 6vw, 32px)" }}>
      <section
        style={{
          background,
          border,
          padding: "clamp(20px, 5vw, 32px)",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          display: "grid",
          gap: "clamp(12px, 3vw, 18px)",
        }}
      >
        <h1
          className="mono"
          style={{ letterSpacing: "0.18em", textTransform: "uppercase", color: heading, fontSize: "clamp(24px, 6vw, 32px)" }}
        >
          {title}
        </h1>
        <p className="small" style={{ textTransform: "none", color: muted }}>
          {children}
        </p>
      </section>
    </main>
  )
}
